import queryString from 'query-string';
import { CT_PERF_URL } from '@/config';

/* eslint-disable import/prefer-default-export */
export function notificationParams(state, getters) {
  const parentIds = getters.getRouteQuery.parent_ids;

  if (!parentIds) {
    return null;
  }

  const studentName = getters.currentUser.name;
  const queryParams = {
    student_name: studentName,
    grade: getters.currentUser.grade_id,
    student_id: getters.currentUser.id,
    source: 'classting',
  };

  const targetUrl = `${CT_PERF_URL}/parent-view?${queryString.stringify(queryParams)}`;

  return {
    target_user_ids: parentIds,
    target_role: 'parent',
    target_url: encodeURIComponent(targetUrl),
    contents: {
      en: `${studentName} just finished learning. Check ${studentName}'s learning performance now.`,
      ko: `${studentName} 학생이 학습을 완료했습니다. 지금 학습 퍼포먼스를 확인해보세요.`,
    },
  };
}
/* eslint-enable */
